import axios from "axios";
import { GET_ALL_COUNTRIES, GET_ALL_COUNTRIES_BY_REGION, ASSIGN_COUNTRY_TO_USER } from '../../constants/api'
import { ShowException } from '../utils/tostar';

export const getAllCountries = () => {
    return axios.get(GET_ALL_COUNTRIES)
        .then(resp => {
            return resp;
        }, err => {
            ShowException(err);
            return err;
        })
}

export const getAllCountriesByRegionCall = () => {
    return axios.get(GET_ALL_COUNTRIES_BY_REGION)
        .then(resp => {
            return resp;
        }, err => {
            ShowException(err);
            return err;
        })
}

export const getAllCountriesByRegionCallById = async (data: any) => {
    return await axios.get(GET_ALL_COUNTRIES_BY_REGION + `/${data.payload.isDashboard ? data.payload.surveyId : data.payload }`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const assignCountryToUserCall = async (id: any) => {
    const resp = axios.put(ASSIGN_COUNTRY_TO_USER + id)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
    return resp;
}


// WEBPACK FOOTER //
// ./src/effects/api/api.common.tsx